import { createSelector } from "@reduxjs/toolkit";

import { dataSelector } from "./helpers";
import { IDataKeys } from "shared/types";
import { buildData } from "Bands/state";
import { IBandSubscription } from "Bands/types";

export const subscriptionsSelector = createSelector(
  dataSelector,
  data => (buildData(data as any, IDataKeys.subscription) || []) as IBandSubscription[]
);
